import moment from "moment"
import axios from "axios"
import router from "../../router"
export default {
  namespaced: true,
  state: {
    receipts: [],
    details: {},
  },
  mutations: {
    SET_RECEIPTS(state, payload) {
      state.receipts = payload
    },
    SET_DETAILS(state, payload) {
      state.details = payload
    },
  },
  actions: {
    async deleteReceipt({ commit, dispatch }, payload) {
      this.state.Global.loader = true
      let response = await axios.post("deleteReceipt", { id: payload })
      var data = response.data.data
      console.log(data)
      if (response) {
        this.state.Global.loader = false
        dispatch(
          "Global/alert",
          {
            value: true,
            text: response.data.message,
            type: "success",
          },
          { root: true }
        )
        router.push({ name: "Home" })
      } else {
        this.state.Global.loader = false
        var data = response.data.data
        dispatch(
          "Global/alert",
          {
            value: true,
            text: response.data.message,
            type: "error",
          },
          { root: true }
        )
      }
    },
    async sendReceipt({ commit, dispatch }, payload) {
      this.state.Global.loader = true
      if (
        payload.date &&
        payload.amount &&
        payload.receipt_id &&
        payload.details
      ) {
        let response = await axios.post("createCashReceipt", payload)
        var data = response.data.data
        if (response) {
          console.log(data)
          this.state.Global.loader = false
          dispatch(
            "Global/alert",
            {
              value: true,
              text: response.data.message,
              type: "success",
            },
            { root: true }
          )
          router.push({ name: "Home" })
        } else {
          this.state.Global.loader = false
          var data = response.data.data
          dispatch(
            "Global/alert",
            {
              value: true,
              text: response.data.message,
              type: "error",
            },
            { root: true }
          )
        }
      } else {
        this.state.Global.loader = false
        dispatch(
          "Global/alert",
          {
            value: true,
            text: "Isi semua data",
            type: "error",
          },
          { root: true }
        )
      }
    },
    async getReceiptDetail({ commit, dispatch }, payload) {
      this.state.Global.loader = true
      let response = await axios.post("getReceiptDetail", { id: payload })
      var data = response.data.data
      console.log(data)
      if (response) {
        this.state.Global.loader = false
        commit("SET_DETAILS", data)
        router.push({ name: "Details" })
      } else {
        this.state.Global.loader = false
        var data = response.data.data
        dispatch(
          "Global/alert",
          {
            value: true,
            text: response.data.message,
            type: "error",
          },
          { root: true }
        )
      }
    },
    async approve({ commit, dispatch }, payload) {
      this.state.Global.loader = true
      let response = await axios.post("approveReceipt", { id: payload })
      var data = response.data.data
      console.log(data)
      if (response) {
        this.state.Global.loader = false
        dispatch(
          "Global/alert",
          {
            value: true,
            text: response.data.message,
            type: "success",
          },
          { root: true }
        )
        router.push({ name: "Home" })
      } else {
        var data = response.data.data
        this.state.Global.loader = false
        dispatch(
          "Global/alert",
          {
            value: true,
            text: response.data.message,
            type: "error",
          },
          { root: true }
        )
      }
    },
    async disapprove({ commit, dispatch }, payload) {
      this.state.Global.loader = true
      let response = await axios.post("disapproveReceipt", { id: payload })
      var data = response.data.data
      console.log(data)
      if (response) {
        dispatch(
          "Global/alert",
          {
            value: true,
            text: response.data.message,
            type: "success",
          },
          { root: true }
        )
        router.push({ name: "Home" })
      } else {
        var data = response.data.data
        dispatch(
          "Global/alert",
          {
            value: true,
            text: response.data.message,
            type: "error",
          },
          { root: true }
        )
      }
    },
    async getReceipts({ commit, dispatch }, payload) {
      this.state.Global.loader = true
      let response = await axios.post("getReceipts", payload)
      var data = response.data.data
      if (response) {
        this.state.Global.loader = false
        commit("SET_RECEIPTS", data)
      } else {
        this.state.Global.loader = false
        var data = response.data.data
        dispatch(
          "Global/alert",
          {
            value: true,
            text: response.data.message,
            type: "error",
          },
          { root: true }
        )
      }
    },
  },
  getters: {
    receipts(state) {
      return state.receipts
    },
    details(state) {
      return state.details
    },
  },
}
